@if(loading | async) {
  <div class="spinner-container d-flex justify-content-center align-items-center">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <app-nav></app-nav>
  <app-sidebar-drawer></app-sidebar-drawer>
}